<div class="group_input">
  <select [ngClass]="{ invalid: invalid | async }" [attr.name]="name" [(ngModel)]="value">
    <option [ngValue]="undefined" hidden>{{ 'Not Selected' | translate }}</option>
    <option *ngFor="let item of items" [ngValue]="item.value || item">
      {{ (item.name || item.value || item) | translate }}
    </option>
  </select>
  <span *ngIf="title" class="bar"></span>
  <label *ngIf="title"><span *ngIf="required">* </span>{{ title | translate }}</label>
</div>
